import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, commons, FixedDropDownButton, Icon, modal} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, DropdownItem, Row} from "reactstrap";
import * as adresaFormatter from "../utils/adresaFormatter";
import {getUplnaAdresa} from "../utils/adresaFormatter";
const {sinkEvent} = commons;
import AdresaForm from "../forms/AdresaForm";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import * as subjektActions from "../actions/subjektActions";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Panel zobrazující seznam adres.
 * Vyžaduje ID společnosti nebo uživatele ke které zobrazované adresy patří.
 * Pokud není předáno ani jedno nebo jsou předány obě, neumožní vytváření/editaci/zobrazení detailu adres.
 */
class AdresyPanel extends Component<WithTranslation> {

    static propTypes = {
        adresyList: PropTypes.array.isRequired, // seznam adres
        spolecnostId: PropTypes.number, // ID společnosti, pokud je vyplněno, bude nově vytvořená adresa připojena k této společnosti
        uzivatelId: PropTypes.number, // ID uživatele, pokud je vyplněno, bude nově vytvořená adresa připojena k tomuto uživateli
        uzivatelMaSpolecnost: PropTypes.bool, // zda má uživatel (odpovídající uzivatelId) přiřazenu alespoň jednu společnost
        readOnly: PropTypes.bool, // zda nezobrazit akce pro editaci a přidávání adres, implcitně true
    };

    static defaultProps = {
        readOnly: true,
    };

    /**
     * Vrací true pokud bylo předáno pouze ID společnosti nebo pouze ID uživatele.
     * @returns {AdresyPanel.props.spolecnostId|AdresyPanel.props.uzivatelId|boolean}
     */
    arePropsValid = () => {
        const {spolecnostId, uzivatelId} = this.props;
        return (spolecnostId || uzivatelId) && !(spolecnostId && uzivatelId);
    };

    componentDidMount() {
        const {spolecnostId, uzivatelId} = this.props;
        if (!(spolecnostId || uzivatelId)) {
            console.error('[AdresyPanel] Nebylo předáno ID společnosti ani uživatele - zakládání/editace/zobrazení adres nebude fungovat!');
        } else if (spolecnostId && uzivatelId) {
            console.error('[AdresyPanel] Bylo předáno ID společnosti i uživatele - zakládání/editace/zobrazení adres nebude fungovat!');
        }
    };

    handleCreateAdresa = () => {
        const {spolecnostId, uzivatelId, uzivatelMaSpolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            AdresaForm,
            {
                onSubmit: (data) => {
                    return spolecnostId ? SubjektApi.createAdresaSpolecnost(data, spolecnostId)
                        : SubjektApi.createAdresaUzivatel(data, uzivatelId);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    spolecnostId ? dispatch(subjektActions.invalidateAdresySpolecnost(spolecnostId))
                        : dispatch(subjektActions.invalidateAdresyUzivatel(uzivatelId));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                showFakturacni: !uzivatelMaSpolecnost
            },
            spolecnostId ? t('address.new_address_company') : t('address.new_address_user'),
            {size: "md"}
        ));
    };

    handleEditAdresa = (adresa) => {
        const {spolecnostId, uzivatelId, uzivatelMaSpolecnost, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            AdresaForm,
            {
                onSubmit: (data) => {
                    return spolecnostId ? SubjektApi.updateAdresaSpolecnost(data, spolecnostId, data.id)
                        : SubjektApi.updateAdresaUzivatel(data, uzivatelId, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    spolecnostId ? dispatch(subjektActions.invalidateAdresySpolecnost(spolecnostId))
                        : dispatch(subjektActions.invalidateAdresyUzivatel(uzivatelId));
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: adresa,
                showFakturacni: !uzivatelMaSpolecnost
            },
            spolecnostId ? t('address.edit_address_company') : t('address.edit_address_user'),
            {size: "md"}
        ));
    };

    handleDeleteAdresa = (adresa) => {
        const {uzivatelId, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('address.delete'),
                t('address.delete_confirm', {address: getUplnaAdresa(adresa)}),
                () => {
                    const novaAdresa = {...adresa};
                    novaAdresa.neaktivni = true;
                    SubjektApi.updateAdresaUzivatel(novaAdresa, uzivatelId, novaAdresa.id).then(() => {
                        this.props.dispatch(subjektActions.invalidateAktivniAdresyUzivatel(uzivatelId));
                    });
                },
                null,
                t('delete')
            )
        );
    };

    renderActions = () => {
        const {readOnly, t} = this.props;
        return <ButtonToolbar>
            {!readOnly && <Button onClick={this.handleCreateAdresa}>{t('new_f')}</Button>}
        </ButtonToolbar>
    };

    renderContextMenu = (adresa) => {
        const {readOnly, t} = this.props;
        return !readOnly ? <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditAdresa.bind(this, adresa))}>{t('edit')}</DropdownItem>
            <DropdownItem key="1" onClick={sinkEvent(this.handleDeleteAdresa.bind(this, adresa))}>{t('delete')}</DropdownItem>
        </FixedDropDownButton> : null
    };

    render() {
        const {adresyList, readOnly, t} = this.props;
        return <Card className="adresy-panel">
            <CardHeader>
                <ActionsRow actions={this.arePropsValid() ? this.renderActions() : null}>
                    <h2>{t('address.title_many')}</h2>
                </ActionsRow>
            </CardHeader>
            <div className="items-list">
                {adresyList.length > 0 ? adresyList.map(adresa =>
                    <CardBody key={adresa.id} className={adresa.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.arePropsValid() ? this.renderContextMenu(adresa) : null} onClick={this.arePropsValid() && !readOnly ? this.handleEditAdresa.bind(this, adresa) : null}>
                            <Row>
                                <Col>
                                    {adresaFormatter.getUplnaAdresa(adresa)}
                                </Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>
                ) : <CardBody><i>{t('address.no_addresses')}</i></CardBody>}
            </div>
        </Card>
    }
}

export default connect()(withTranslation()(AdresyPanel));
